/**
 * Normalizes a Russian phone number to E.164 format (+7XXXXXXXXXX).
 * Accepts formats: 89001234567, 79001234567, +79001234567, 9001234567
 */
export function normalizePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '')

  if (digits.length === 11) {
    if (digits.startsWith('8') || digits.startsWith('7')) {
      return '+7' + digits.slice(1)
    }
  }

  if (digits.length === 10) {
    return '+7' + digits
  }

  return '+' + digits
}

export function isValidNormalizedPhone(phone: string): boolean {
  return /^\+7\d{10}$/.test(phone)
}
